const truncate = (value: string): string => {
  const maxIndexByFirstHalf = Math.trunc(value.length * 0.17)
  const minIndexByLastHalf = value.length - Math.trunc(value.length * 0.12)
  return `${value.slice(0, maxIndexByFirstHalf)}...${value.slice(minIndexByLastHalf, value.length)}`
}

export default truncate
